import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function formatTime(seconds) {

    const hours = String(
        Math.floor(seconds / 3600)
    ).padStart(2, '0');

    const minutes = String(
        Math.floor((seconds % 3600) / 60)
    ).padStart(2, '0');

    const secs = String(
        seconds % 60
    ).padStart(2, '0');

    return `${hours}:${minutes}:${secs}`;
}

export default function useRecordingTimer() {

    const startedAt = useSelector(
        (state) => state.recorder.startedAt
    );

    const status = useSelector(
        (state) => state.recorder.status
    );

    const [duration, setDuration] =
        useState('00:00:00');

    useEffect(() => {

        if (
            !startedAt ||
            status !== 'recording'
        ) {

            setDuration('00:00:00');

            return;
        }

        const interval = setInterval(() => {

            const diff = Math.floor(
                (Date.now() - startedAt) / 1000
            );

            setDuration(
                formatTime(diff)
            );

        }, 1000);

        return () => clearInterval(interval);

    }, [startedAt, status]);

    return duration;
}